export default __webpack_public_path__ + "static/media/green_arrow.644be235.svg";